/**
 * The reducer function which will update and apply logical functions to the 
 * state.
 * 
 * @param {Object} state - The current state of the form
 * @param {Object} action - The action to be taken by the reducer
 */
export default (state, action) => {
    switch (action.type) {
        case 'UPDATE':
            return {
                ...state,
                [action.param]: {
                    ...state[action.param],
                    value: action.value,
                    hasError: false,
                    errorMessage: ''
                }
            };
        case 'ADD_ERROR':
            return {
                ...state,
                [action.param]: {
                    ...state[action.param],
                    hasError: true,
                    errorMessage: action.message
                }
            };
        case 'CLEAR':
            return action.default;
        case 'EDIT_MODE':
            let editedState = { ...action.default };
            // Assign values in the object
            for (let param in action.values) {
                editedState[param].value = action.values[param];
            }

            return editedState;
        default:
            return state;
    }
}